// This reducer is meant to be used by the activity builder to track
// steps that may not be fully saved yet so that they can be comapred 
// to the steps on the activity, and to track position
import { createSlice } from '@reduxjs/toolkit'

export const onAddStepReducer = (state) => {
  const steps = [...state.steps]
  const stepsToSave = [...state.stepsToSave]
  const index = steps.findIndex(s => +s.id === 0)
  if (index !== -1) {
    stepsToSave.push(steps[index])
  } else {
    steps.push({
      description: '',
      title: '',
      id: 0,
      position: steps.length,
      saved: false
    })
  }
  return {
    ...state,
    stepsToSave,
    steps
  }
}

export const onReorderStepsReducer = (state, { payload }) => {
  const { steps, forceStepSave } = payload

  const newState = {
    ...state,
    steps,
    forceStepSave
  }

  return newState
}

const onSaveStepsReducer = (state, { payload }) => {
  const { steps } = payload
  return {
    ...state,
    steps
  }
}

const onUpdateStepsToSaveReducer = (state, { payload }) => {
  const { stepsToSave } = payload

  const newState = {
    ...state,
    stepsToSave
  }
  if (stepsToSave.length === 0) {
    newState.forceStepSave = null
  }
  return newState
}

const onUpdateForceStepSaveReducer = (state, { payload }) => {
  const { forceStepSave } = payload
  return {
    ...state,
    forceStepSave
  }
}

const stepSlice = createSlice({
  name: 'steps',
  initialState: {
    steps: [],
    stepsToSave: [],
    forceStepSave: null
  },
  reducers: {
    onAddStep: onAddStepReducer,
    onReorderSteps: onReorderStepsReducer,
    onSaveSteps: onSaveStepsReducer,
    onUpdateStepsToSave: onUpdateStepsToSaveReducer,
    onUpdateForceStepSave: onUpdateForceStepSaveReducer
  }
})

const { actions, reducer } = stepSlice

export const {
  onAddStep,
  onReorderSteps,
  onSaveSteps,
  onUpdateStepsToSave,
  onUpdateForceStepSave
} = actions

export default reducer
